import type { CSSProperties } from "react";
import { Text } from "../../typography";
import { classNames } from "../../utils/classNames";

type ScheduleLabelChipProps = {
	label: string;
	className?: string;
	style?: CSSProperties;
};

export const ScheduleLabelChip = ({ label, className, style }: ScheduleLabelChipProps) => (
	<div className={classNames("flex items-center justify-center rounded-md bg-info-faded", className)} style={style}>
		<Text size="sm" weight="medium" className="text-info">
			{label}
		</Text>
	</div>
);
